<template>
  <v-container>
    <v-card class="pa-4">
      <v-row>
        <v-col cols="12">
          <v-list>
            <v-list-item v-if="isSubMerchant">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <span class="field-label">Nama Aggregator</span>
                  </v-col>
                  <v-col cols="12" sm="1" class="d-none d-sm-flex">:</v-col>
                  <v-col cols="12" sm>{{ merchantData.aggregator_name }}</v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <span class="field-label">Nama Merchant</span>
                  </v-col>
                  <v-col cols="12" sm="1" class="d-none d-sm-flex">:</v-col>
                  <v-col cols="12" sm>{{ merchantData.merchant_name }}</v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <span class="field-label">MID</span>
                  </v-col>
                  <v-col cols="12" sm="1" class="d-none d-sm-flex">:</v-col>
                  <v-col cols="12" sm>{{ merchantData.mid }}</v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <span class="field-label">Email</span>
                  </v-col>
                  <v-col cols="12" sm="1" class="d-none d-sm-flex">:</v-col>
                  <v-col cols="12" sm>{{ merchantData.email }}</v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <span class="field-label">Versi Client</span>
                  </v-col>
                  <v-col cols="12" sm="1" class="d-none d-sm-flex">:</v-col>
                  <v-col cols="12" sm>{{ merchantData.client_type }}</v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <span class="field-label">Callback Partner ID</span>
                  </v-col>
                  <v-col cols="12" sm="1" class="d-none d-sm-flex">:</v-col>
                  <v-col cols="12" sm>{{ merchantData.callback_partner_id }}</v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <span class="field-label">Callback Partner Client Secret</span>
                  </v-col>
                  <v-col cols="12" sm="1" class="d-none d-sm-flex">:</v-col>
                  <v-col cols="12" sm>{{ merchantData.callback_partner_secret }}</v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <span class="field-label">Callback Partner URL Token</span>
                  </v-col>
                  <v-col cols="12" sm="1" class="d-none d-sm-flex">:</v-col>
                  <v-col cols="12" sm>{{ merchantData.callback_partner_url_token }}</v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <span class="field-label">Public Key Partner</span>
                  </v-col>
                  <v-col cols="12" sm="1" class="d-none d-sm-flex">:</v-col>
                  <v-col cols="12" sm class="d-flex align-center">
                    <v-textarea
                      v-model="decryptedPublicKey"
                      outlined
                      disabled
                      dense
                      readonly
                      rows="2"
                      class="fixed-height-textarea"
                      hide-details
                    ></v-textarea>
                    <v-tooltip
                      v-model="showCopyTooltip"
                      bottom
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          size="18"
                          class="ml-2 cursor-pointer"
                          v-bind="attrs"
                          v-on="on"
                          @click="copyToClipboard(decryptedPublicKey)"
                        >
                          mdi-clipboard-multiple
                        </v-icon>
                      </template>
                      <span>{{ copyTooltipText }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3">
                    <span class="field-label">URL</span>
                  </v-col>
                  <v-col cols="12" sm="1" class="d-none d-sm-flex">:</v-col>
                  <v-col cols="12" sm>{{ merchantData.callback_url }}</v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>

    <TableView
      :headers="detailHeaders"
      :items="allData"
      :loading="loading"
      :options.sync="options"
      :totalData="totalData"
      :refresh-table="getData"
      :bodyFilter="true"
    >
      <template v-slot:body-prepend>
        <BodyFilterView
          :filters="filterData"
          :search.sync="search"
          :options.sync="options"
          @getDataParent="getData"
        />
      </template>
    </TableView>

      <v-row class="mt-4">
        <v-col cols="12" class="text-center">
          <v-btn
            color="primary"
            @click="goBack"
          >
            BACK
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import detailMerchantCallbackMixin from '../../components/merchant-callback-management/detailMerchantCallbackMixin';

export default {
  name: 'DetailManagementMerchantApi',
  mixins: [ detailMerchantCallbackMixin ],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    BodyFilterView: () => import("../../components/@drontVue/components/BodyFilter"),
  },
};
</script>

<style scoped>
.grey--text {
  color: rgba(0, 0, 0, 0.6) !important;
}

.fixed-height-textarea ::v-deep .v-input__slot {
  max-height: 100px !important;
}

.fixed-height-textarea ::v-deep textarea {
  line-height: 1.2;
  font-family: monospace;
  overflow-y: auto !important;
}

.cursor-pointer {
  cursor: pointer;
}

.field-label {
  color: rgba(0, 0, 0, 0.6);
  font-weight: 600;
  display: inline-block;
  margin-bottom: 8px;
}

@media (max-width: 600px) {
  .v-list-item {
    padding: 8px 0;
  }
  
  .field-label {
    margin-bottom: 4px;
  }
  
  .v-list-item__content {
    padding: 4px 0;
  }
}
</style>
